export default __webpack_public_path__ + "static/media/food.4af2380a.jpg";